import Vue from 'vue'

// Helpers components
Vue.component('pml-back-button', require('./helpers/BackButton.vue').default)
Vue.component('pml-pagination', require('./helpers/Pagination.vue').default)
Vue.component('pml-fullcalendar', require('./helpers/full_calendar/Main.vue').default)

// Empty charts components
Vue.component('pml-ec-pizza', require('./helpers/empty-charts/Pizza.vue').default)
Vue.component('pml-ec-bar', require('./helpers/empty-charts/Bar.vue').default)
Vue.component('pml-ec-line', require('./helpers/empty-charts/Line.vue').default)

// Layout components
Vue.component('login-layout', require('./layouts/Login.vue').default)
Vue.component('master-layout', require('./layouts/Master.vue').default)

// Root components
Vue.component('pml-footer', require('./root/Footer.vue').default)
Vue.component('pml-header', require('./root/header/Main.vue').default)
Vue.component('pml-main-menu', require('./root/MainMenu.vue').default)
Vue.component('pml-floating-menu', require('./root/FloatingMenu.vue').default)

// Parameters components
Vue.component('pml-exchange-rates-modal', require('../modules/parameters/exchange_rate/components/Main.vue').default)
Vue.component('pml-sources-modal', require('../modules/parameters/sources/components/Main.vue').default)

// Form components
Vue.component('pml-checkbox', require('./form/Checkbox.vue').default)
Vue.component('pml-color-picker', require('./form/ColorPicker.vue').default)
Vue.component('pml-date-picker', require('./form/DatePicker.vue').default)
Vue.component('pml-datetime-picker', require('./form/DatetimePicker.vue').default)
Vue.component('pml-dropzone', require('./form/Dropzone.vue').default)
Vue.component('pml-multiselect', require('./form/Multiselect.vue').default)
Vue.component('pml-numeric', require('./form/Numeric.vue').default)
Vue.component('pml-select', require('./form/Select.vue').default)
Vue.component('pml-select-group', require('./form/SelectGroup.vue').default)
Vue.component('pml-select-countries', require('./form/selects/Countries.vue').default)
Vue.component('pml-select-currencies', require('./form/selects/Currencies.vue').default)
Vue.component('pml-select-deals', require('./form/selects/Deals.vue').default)
Vue.component('pml-select-members', require('./form/selects/Members.vue').default)
Vue.component('pml-switch', require('./form/Switch.vue').default)
Vue.component('pml-summernote', require('./form/Summernote.vue').default)
Vue.component('pml-autocomplete-tag-input', require('./form/AutoCompleteTagInput.vue').default)

// External
Vue.component('vue-multiselect', require('vue-multiselect').default)
Vue.component('vue-draggable', require('vuedraggable'))



// WEBPACK FOOTER //
// ./src/components/index.js